/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { Box } from '@mui/material';
import LogoDevIcon from '@mui/icons-material/LogoDev';
import { useEffect, useState } from 'react';
import styles from '../../../styles/leftNav.module.css';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../redux/hooks';
import { isLoggedInSelector, UserType } from '../../../redux/loginSlice';
import { ReactComponent as Logo } from "../../../images/Logo.svg";
import { configOptions } from '../../../config/index';

const LeftNavSection = () => {

  const [isExpanded, setIsExpanded] = useState(false)
  const [style,setStyle]= useState<React.CSSProperties | undefined>({display:'none'});
  const navigate = useNavigate();

  const location = useLocation();
  const windowObject: any = window;
  const [name, setName] = useState();


  const { isLoggedIn, user } = useAppSelector(isLoggedInSelector);

  useEffect(() => {
    (async () => {
      if (!!user) {

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let userInfo = user ? (user as any).name?.replace(/\w\S*/g, (w: string) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : user;
        console.log("navigation" + JSON.stringify(userInfo))
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setName(userInfo as any);
      }
    })();
  }, [user]);

  useEffect(() => {

  }, [location]);

  return (
    <>    {!!user &&
      <rotor-nav is-vertical //is-expanded={isExpanded} 
      // onMouseEnter={(value) => {
      //   // setStyle({display:'flex'})
      //   setIsExpanded(true)
      // }} onMouseOut={(() => {
      // //   setStyle({display:'flex'})
      //   setIsExpanded(false)
      // })}

      >
        <rotor-nav-brand>
             
        <a href={configOptions.lifeRayURL}>
          <div style={{display:'flex'}}>
          <div style={{paddingTop:"8px",paddingBottom:"8px",paddingLeft:"4px"}}>
          <Logo />
          </div>
          <rotor-nav-brand-title 
            style={{fontWeight:"500",fontSize:"16px",
                    fontFamily:"Barlow Semi Condensed", 
                    fontStyle:"normal", letterSpacing:"0.25px", textTransform:"uppercase", 
                    color: "#FFFFFF", paddingLeft: "10px",paddingBottom : "12px", paddingTop :"12px",paddingRight:"119px"}} >
            Portal Registration
          </rotor-nav-brand-title>
          </div></a>
        </rotor-nav-brand>

        <rotor-nav-items>
          <div className={styles.navTabs}>
            <rotor-nav-item icon="home" is-active={location.pathname === '/dashboard'} onClick={() => {
              navigate('dashboard') 
            }} >
              <span className={styles.navTabsSpan}>Dashboard</span>
            </rotor-nav-item>
          </div>
          <div className={styles.navTabs}>
            <rotor-nav-item icon="folder-closed" is-active={location.pathname === '/roleRequest'} onClick={() => {
              navigate('/roleRequest?tab=myResources')
            }} >
              <span className={styles.navTabsSpan}>Manage Resources</span>
            </rotor-nav-item>
          </div>
          <div className={styles.navTabs}>
            <rotor-nav-item icon="gear" is-active={location.pathname === '/myProfile'} onClick={() => {
              navigate('/myProfile?tab=personnelInfo')
            }} >
              <span className={styles.navTabsSpan}>Account Settings</span>
            </rotor-nav-item>
          </div>
          <div className={styles.navTabs}>
            {(user?.userType === UserType.ADMIN || user?.userType === UserType.SUPER_ADMIN) && <rotor-nav-item icon="lock-closed" onClick={() => {
              window.open("../../enduser/?realm=PnW/");
            }}>
              <span className={styles.navTabsSpan}>Admin</span>
            </rotor-nav-item>}
          </div>

          {/*  <rotor-nav-item icon="user" is-active={location.pathname === '/myprofile'} onClick={() => {
          navigate('/myProfile?tab=personnelInfo')
        }} >
          <span>My Account</span>
        </rotor-nav-item> */}

        </rotor-nav-items>
        {/* <div className="footer-navigation" style={style}> */}
        <div className="footer-navigation" style={{display:'flex'}}>
        <div className={styles.navDivs}>
          <a className={styles.navLinks} href="https://www.rtx.com/Privacy" target="_blank">Privacy Statement</a>
        </div>
        <div className={styles.navDivs}>
          <a className={styles.navLinks} href="https://links.prattwhitney.com/body/html/terms.html" target="_blank">Website Agreement</a>
        </div>
        <div className={styles.navDivs}> 
          <a className={styles.navLinks} href="mailto:portalidentity@prattwhitney.com " target="_blank">Contact Us</a>
        </div>
        <div className={styles.navDivs}>
          <a className={styles.navLinks}>Help Desk: (860) 565-3550</a>  
        </div>
        <div className={styles.navDivs}></div>
      </div>

        <rotor-nav-items is-bottom>
          <rotor-nav-avatar icon='user' 
          // onClick={() => {
          //   navigate('/myProfile?tab=personnelInfo')
          // }} 
          >
            <span > <div className={styles.navTabsFooter}>{name}</div></span>
          </rotor-nav-avatar>
          <rotor-nav-item onClick={async () => { await windowObject.logout(); }}>
            <span  className={styles.navTabsFooter}>Sign Out</span>
          </rotor-nav-item>
        </rotor-nav-items>
      </rotor-nav>
    }
    </>

  );
};

export default LeftNavSection;
